import * as triggers from 'constants/commerceTriggers';
import { PRODUCT_MENTIONED, RECENT_ORDER, GLOBAL_FALLBACK } from 'constants/commerceDetectionTypes';

export const removeCommerceTriggers = (text) => {
  // remove leading breaking spaces
  let result = text.replace(`<br><br>${triggers.RECOMMEND_A_PRODUCT_TRIGGER}`, '');

  return result.replace(triggers.RECOMMEND_A_PRODUCT_TRIGGER, '');
};

export const getReadableDetectionSource = (detectionSource) => {
  switch (detectionSource) {
    case PRODUCT_MENTIONED:
      return 'Product mentioned by customer';
    case RECENT_ORDER:
      return 'Product recently purchased by customer';
    case GLOBAL_FALLBACK:
      return 'Product globally recommended by partner';
    default:
      return 'Unknown';
  }
};
